/**
 * Flash-sale countdown that runs for 5 days, then restarts automatically.
 * Shared anchor keeps every visitor on the same loop.
 */
(function () {
  var PERIOD_MS = 5 * 24 * 60 * 60 * 1000; // 5 days
  // Cycle start — periods repeat from this moment so the bar shows a full ~5 days after deploy
  var ANCHOR_MS = Date.UTC(2026, 9, 18, 22, 0, 0);

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function remainingMs() {
    var elapsed = Date.now() - ANCHOR_MS;
    if (elapsed < 0) return PERIOD_MS;
    return PERIOD_MS - (elapsed % PERIOD_MS);
  }

  function format(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(total / 86400);
    var h = Math.floor((total % 86400) / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    return d + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function tick(root) {
    var el = root.querySelector('[data-mm-sale-timer]');
    if (!el) return;
    el.textContent = format(remainingMs());
  }

  function boot() {
    document.querySelectorAll('[data-mm-sale-bar]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      tick(root);
      window.setInterval(function () {
        tick(root);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
